const dialog    = require ('../../../../../components/dialog/dialog')

export function start( detail ){ //console.log('dialog sale detail', detail)

	dialogBody[detail.id].start(detail) 
	
	detail.html =  dialogBody[detail.id]
	dialog.start(detail)
}


const dialogBody = {

	saleSellingPrice: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'',
			class:'button primary',
			dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
			dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
			dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = 'The selling price on the items below is lower than expected.<br> Do you still want to continue?\n' + detail.items
			this.primary.dataDetail   = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
										 {"dest":"providerProfit", "elem":"purchaseFullcont2",  "id":"sale-fullcont2", "act":"${detail.actDialog}", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
			this.primary.text         = detail.mode
								
		}

	},

	SalecreditLimit: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Continue',
			class:'button primary',
			dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
			dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
			dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = "The invoice value exceeds the customer's credit"
			this.primary.dataDetail   = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
										 {"dest":"providerProfit", "elem":"purchaseFullcont2",  "id":"sale-fullcont2", "act":"addOneFromDialog", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
								
		}

	},

	SalecreditLimitPrint: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Continue',
			class:'button primary',
			dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
			dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
			dataDetail:'',
		},      

		start: function(detail){
			this.title     			  = 'Warning'
			this.des       		      = "The invoice value exceeds the customer's credit"
			this.primary.dataDetail   = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
										 {"dest":"providerProfit", "elem":"purchaseFullcont2",  "id":"sale-fullcont2", "act":"addOnePrintFromDialog", "entity":"sale"} ]}'`
			this.secondary.dataDetail = `data-detail='{
										 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
								
		}

	},

	deleteElem: { 
	    title:  '', 
	    des:    ``,
		primary:   { text:'Cancel',       class:'button ',             dataDetail:``, }, //contenct
		secondary: { text:`Delete forever!`	, class:'button  button-flat', dataDetail:``, }, //contenct
		tertiary:  { text:'',             class:'',                    dataDetail:``, },  //contenct
		start: function(detail){
			this.title                = `Do you want delete this ${detail.entity}?`
			this.des            	  = `All the information and files asociated will be deleted`
	        this.primary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`	
			this.secondary.dataDetail  =`data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"${detail.dest}", "elem":"purchaseFullcont2",   "act":"deleteFromDialog",   "entity":"${detail.entity}", "dbid":[${detail.dbid}] } ]}'`
		}/**/
	},

////////////////////////////////////////////////fullcont
	saveChanges: { 
		title:  '',
		des:    `Your changes will be lost if you don't save them`,
		primary:   { text:'Save', class:'button primary', dataDetail:``, },      //contenct
		secondary: { text:`Cancel`	, class:'button secondary  button-plain', dataDetail:``, },      //contenct
		tertiary:  { text:'Discart',   class:'button secondary  button-plain', dataDetail:``,   },      //contenct
		start: function(detail){
			this.title                  = `Do you want save the changes made to the ${detail.entity}?`
			this.primary.dataDetail     =  `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"${detail.dest}", "elem":"purchaseFullcont2",  "id":"${detail.entity}-fullcont3", "act":"saveFromDialog"} ]}'`
	        this.secondary.dataDetail   =`data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`	        
	        this.tertiary.dataDetail    =`data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"${detail.dest}", "elem":"purchaseFullcont2", "id":"${detail.entity}-fullcont3", "act":"discard"} ]}'`

		}
	},
}